// hooks/useCommercialCount.js
import { useEffect, useState } from 'react';

const STORAGE_KEY = 'pesa_commercial_scenarios'; // à adapter

export function useCommercialCount() {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const scenarios = raw ? JSON.parse(raw) : [];
      // Si on stocke un objet avec une propriété `scenarios` ou un tableau directement
      setCount(Array.isArray(scenarios) ? scenarios.length : 0);
    } catch {
      setCount(0);
    } finally {
      setLoading(false);
    }
  }, []);

  return { count, loading };
}